<template>
  <div id="hotsite-container">
    <MainContentHotSite />
    <Plans />
  </div>
</template>
<style scoped>
html,
body {
  overflow-x: hidden;
}
#hotsite-container {
  font-family: Inter;
  margin-top: -140px;
}
</style>
<script>
// Importe o arquivo Vue do componente filho
import Plans from "./components/plans/plans.vue";

export default {
  components: {
    Plans,
  },

  data() {
    return {
      isHotSite: undefined,
    };
  },

  mounted() {},
};
</script>



// WEBPACK FOOTER //
// hotsite.vue?3b919def